var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "header-middel",
    class: {
      globalControl: _vm.$route.name == 'globalControl'
    }
  }, [_c('el-select', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.listScroll,
      expression: "listScroll"
    }],
    ref: "selectBox",
    staticClass: "selectBox m_r_20",
    attrs: {
      "visible-arrow": false,
      "placeholder": _vm.returnPlaceholder,
      "no-data-text": _vm.returnNoData,
      "no-match-text": _vm.returnNoData,
      "filterable": "",
      "filter-method": val => {
        _vm.getOutputList('filter', '', val);
      },
      "disabled": _vm.showSelectBox || _vm.selectOutputType == 'Tag',
      "popper-class": _vm.returnClass
    },
    on: {
      "visible-change": val => {
        if (val) _vm.getOutputList('getReceiverList', 'visiable', val);
      }
    },
    nativeOn: {
      "mouseover": function ($event) {
        return _vm.showTagTooltip('enter');
      },
      "mouseout": function ($event) {
        return _vm.showTagTooltip('leave');
      }
    },
    model: {
      value: _vm.selectOutput,
      callback: function ($$v) {
        _vm.selectOutput = $$v;
      },
      expression: "selectOutput"
    }
  }, _vm._l(_vm.outputList, function (item) {
    return _c('el-option', {
      key: item.mainwindowId,
      attrs: {
        "label": item.name,
        "value": item.mainwindowId
      }
    }, [_c('div', {
      on: {
        "click": function ($event) {
          return _vm.showVfbDialog(item);
        }
      }
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), item.email ? _c('p', {
      staticClass: "email"
    }, [item.email == _vm.State.loginInfo.email ? _c('span', [_vm._v("(" + _vm._s(_vm.$t('kioskHost.me')) + ")")]) : _vm._e(), _vm._v(_vm._s(item.email))]) : _vm._e()])]);
  }), 1), _c('el-button', {
    staticClass: "outputBtn m_r_10",
    class: {
      grays: _vm.sendBtnColor == 'gray',
      'green-gradient': _vm.sendBtnColor == 'green',
      'red-gradient': _vm.sendBtnColor == 'red'
    },
    attrs: {
      "disabled": _vm.sendBtnColor == 'gray' || (_vm.sendBtnColor == 'red' && JSON.stringify(_vm.globalMainInfo) != '{}' ? true : false)
    },
    on: {
      "click": _vm.controlOutput
    }
  }, [_vm._v(" " + _vm._s(_vm.sendBtnColor == 'red' ? _vm.$t('galleryHost.stop') : _vm.$t('galleryHost.send')) + " ")]), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.$t('common.applyAllTips'),
      "placement": "top"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$route.name === 'globalControl',
      expression: "$route.name === 'globalControl'"
    }],
    staticClass: "applyAll",
    attrs: {
      "disabled": !_vm.selectOutput && _vm.selectOutputType != 'Tag' || _vm.selectOutputType == 'Tag' && _vm.sendBtnColor == 'green'
    },
    on: {
      "click": _vm.sendApplyAll
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.applyAll')) + " ")])], 1), _vm.sourceVfbType.show ? _c('select-source-type', {
    attrs: {
      "info": _vm.sourceVfbType,
      "sendReceiverInfo": _vm.sendReceiverInfo,
      "loadingBtn": _vm.liveLoading,
      "appendToBody": true,
      "showAudioHtml": true,
      "pageNum": _vm.pageNum
    },
    on: {
      "updateVfbData": _vm.updateVfbData,
      "updateTagStage": _vm.updateTagStage
    }
  }) : _vm._e(), _vm.encoderInfo.visible ? _c('EncoderInfo', {
    attrs: {
      "info": _vm.encoderInfo,
      "appendToBody": true
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };